export const isAdminLike = (role) => role === 'admin' || role === 'owner'

export const ROLE_LABELS = {
  owner: 'Owner',
  admin: 'Admin',
  user: 'Người dùng'
}

export const STATUS_LABELS = {
  active: 'Hoạt động',
  inactive: 'Đã khóa'
}
